<template>
  <transition name="c-invite__fade">
    <BaseModal v-if="invite" @modalState="closeInvite($event)">
      <template v-slot:content>
        <div v-if="modalStep1" class="c-invite c-invite--step1">
          <div class="c-invite__content is-centered">
            <div class="c-invite__header">
              <p
                class="c-invite--highlight has-text-primarydark has-text-weight-bold is-size-7"
              >
                BETA
              </p>
              <h2 class="c-invite__title has-text-grey-darker is-size-5">
                Shopping Casar.com
              </h2>
            </div>
            <div class="c-invite__body">
              <div class="c-invite__description">
                <h1 class="c-invite__subtitle has-text-dark is-size-5">
                  <strong>Você é nosso convidado</strong>
                  <br />
                  para testar essa novidade em primeira mão.
                </h1>
                <p>
                  Com o Shopping Casar.com, você pode utilizar o dinheiro
                  recebido da sua lista virtual para comprar os produtos dos
                  seus sonhos nas melhores lojas do Brasil
                  <strong
                    >e ainda recebe 4% do dinheiro dos produtos de
                    volta.</strong
                  >
                  😀
                </p>
                <p class="c-invite__description--invite">
                  <strong>Ficou interessado?</strong>
                </p>
              </div>
            </div>
            <div class="c-invite__footer">
              <div class="c-invite__actions">
                <button
                  class="c-invite__action button is-primary"
                  @click="step1(true)"
                >
                  Sim, me conte mais
                </button>
              </div>
              <div class="c-invite__actions">
                <button
                  class="c-invite__action button is-outlined is-black"
                  @click="step1(false)"
                >
                  Não obrigado
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="modalStep2" class="c-invite c-invite--step2">
          <div class="c-invite__content is-centered">
            <div class="c-invite__header">
              <p
                class="c-invite--highlight has-text-primarydark has-text-weight-bold is-size-7"
              >
                BETA
              </p>
              <h2 class="c-invite__title has-text-grey-darker is-size-5">
                Shopping Casar.com
              </h2>
            </div>
            <div class="c-invite__body">
              <div class="c-invite__description">
                <p>
                  O Shopping Casar.com já está funcionando 100% e queremos que a
                  experiência dos nossos noivos seja a melhor possível, por
                  isso, te convidamos a testá-lo em primeira mão!
                </p>
                <p>
                  <strong>
                    Queremos que você o use e nos dê sua opinião.
                  </strong>
                  <br />
                  Fale conosco por e-mail ou chat sempre que desejar.
                </p>
                <p>
                  Aceitando, o recurso ficará disponível para uso em seu site.
                </p>
                <p>
                  <strong>Aceita participar?</strong>
                </p>
              </div>
            </div>
            <div class="c-invite__footer">
              <div class="c-invite__actions">
                <button
                  class="c-invite__action button is-primary"
                  @click="step2(true)"
                >
                  Sim. Ativar Shopping!
                </button>
              </div>
              <div class="c-invite__actions">
                <button
                  class="c-invite__action button is-outlined is-black"
                  @click="step2(false)"
                >
                  Não ativar Shopping
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="modalStep3" class="c-invite c-invite--step3">
          <div class="c-invite__content is-centered">
            <div class="c-invite__header">
              <p
                class="c-invite--highlight has-text-primarydark has-text-weight-bold is-size-7"
              >
                NOVIDADE
              </p>
              <h2 class="c-invite__title has-text-grey-darker is-size-5">
                Shopping Casar.com disponível
              </h2>
            </div>
            <div class="c-invite__body">
              <div class="c-invite__description">
                <h1 class="has-text-dark is-size-4">
                  Compre nas melhores lojas e receba 4% do dinheiro de volta
                </h1>
              </div>
              <div class="is-centered">
                <iframe
                  id="video-shopping"
                  width="300"
                  height="180"
                  src="https://www.youtube.com/embed/e1zmCDEGuVk"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                >
                </iframe>
              </div>
            </div>
            <div class="c-invite__footer">
              <div class="c-invite__actions">
                <button
                  class="c-invite__action button is-primary"
                  @click="updatePage"
                >
                  Concluir
                </button>
              </div>
              <div class="c-invite__actions">
                <a
                  class="c-invite__action button is-outlined is-black"
                  :href="learnMoreUrl"
                >
                  Saiba mais
                </a>
              </div>
            </div>
          </div>
        </div>
      </template>
    </BaseModal>
  </transition>
</template>

<script>
import WalletApi from '@/lib/api/Wallet'
import BaseModal from '@/components/BaseModal.vue'

const SITE_URL = process.env.VUE_APP_SITE_URL

export default {
  components: {
    BaseModal,
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },
  },

  data() {
    return {
      globalTagHTML: null,
      isLastSlide: false,
      invite: false,
      modalStep1: true,
      modalStep2: false,
      modalStep3: false,
      walletApi: null,
      learnMoreUrl: SITE_URL + 'shopping-casar-beta',
    }
  },

  mounted() {
    this.fixGlobalTagHTML()
    this.invite = true
  },

  methods: {
    step1(accepted) {
      this.walletApi = new WalletApi(this.logonToken)

      if (accepted === true) {
        this.modalStep1 = false
        this.modalStep2 = true
      } else {
        this.walletApi.setInviteShoppingRejected().finally(() => {
          this.invite = false
          this.fixGlobalTagHTML()
        })
      }
    },

    step2(accepted) {
      if (accepted === true) {
        this.walletApi.setInviteShoppingAccepted().finally(() => {
          this.modalStep2 = false
          this.modalStep3 = true
        })
      } else {
        this.walletApi.setInviteShoppingRejected().finally(() => {
          this.invite = false
          this.fixGlobalTagHTML()
        })
      }
    },

    updatePage() {
      location.reload()
    },

    closeInvite(state) {
      if (this.modalStep3) {
        location.reload()
      }

      this.invite = state
      this.$emit('toggleInvite', state)
      this.fixGlobalTagHTML()
    },

    fixGlobalTagHTML() {
      this.globalTagHTML = document.getElementsByTagName('html')[0]

      if (this.invite) {
        this.globalTagHTML.style.position = 'fixed'
        this.globalTagHTML.style.overflow = 'hidden'
      } else {
        this.globalTagHTML.style.position = 'relative'
        this.globalTagHTML.style.overflow = 'initial'
      }
    },
  },
}
</script>

<style lang="scss">
.c-invite {
  margin: 0 auto;
  @media (min-width: 400px) {
    max-width: 360px;
  }
  @media (min-width: $tablet) {
    max-width: 420px;
  }

  &__fade-enter-active,
  &__fade-leave-active {
    transition: opacity 0.5s;
  }
  &__fade-enter,
  &__fade-leave-to {
    opacity: 0;
  }

  &__header {
    position: relative;
    height: 202px;
    z-index: 1;
    @media (min-width: $tablet) {
      height: 230px;
    }

    &:before {
      content: '';
      border-radius: 6px 6px 0 0;
      background-color: #f5f9fa;
      background-image: url('~@/assets/img/invite-shopping/bg-header-step1.jpg');
      background-size: 100%;
      position: absolute;
      background-position: center bottom;
      background-repeat: no-repeat;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      margin: auto;
      height: 100%;
      z-index: -1;
    }

    p.c-invite--highlight {
      margin: 0;
      padding-top: 10px;
      letter-spacing: 0.07em;
    }
  }

  &__content {
    color: $gray-7;
    text-align: center;
  }

  &__body {
    padding: 1em 1em 0 1em;

    iframe {
      width: 100%;
      height: 200px;
      margin: 1em auto;
    }
  }

  &__description {
    &--invite {
      margin-top: 2em;
    }

    h1 {
      padding: 0;
      font-weight: normal;
      font-size: em(20);

      > strong {
        color: $gray-7;
      }
    }

    h2 {
      margin-top: 0.3em;
      font-size: em(24);
    }

    p {
      color: $gray-6;
      margin: 1em 0;
      letter-spacing: normal;

      > strong {
        color: $gray-6;
      }
    }
  }

  &__footer {
    padding-bottom: 1em;
  }

  &__actions {
    height: 40px;
    width: 200px;
    display: block;
    border-radius: 24px;
    position: relative;
    margin: 0 auto;
    margin-top: 10px;
  }

  &__action {
    width: 100%;
    height: 100%;
  }

  &--step3 .modal-header {
    padding: 0;
  }
}

.c-invite--step2 {
  .c-invite__header:before {
    background-image: url('~@/assets/img/invite-shopping/bg-header-step2.jpg');
  }

  .c-invite__body {
    padding: 0 1em 0 1em;
  }

  .c-invite__description {
    p:first-child {
      margin-top: 0;
    }
  }
}

.c-invite--step3 {
  padding: 0.8em;
  @media (max-width: $tablet) {
    padding: 1em;
  }

  .c-invite__header {
    height: inherit;

    &:before {
      display: none;
    }
  }

  .c-invite__body {
    h1,
    h2 {
      font-weight: bold;
    }
  }
}
</style>
